import Card from '@material-ui/core/Card';
import PropTypes from 'prop-types';
import React from 'react';
import intlEquipped, { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';

import InvoiceItem from '../InvoiceItem';

const InvoicesList = ({
    invoices,
    onInvoiceClick,
    theme,
    i18n,
}) => {
    const { formatMessage } = i18n;

    return ((invoices && invoices.length > 0)
        ? (
            <Card className={ theme.invoicesList } elevation={ 0 } data-testid="invoice-list">
                <section>
                    { invoices.map((invoice, index) => (
                        <InvoiceItem
                            key={ `${index}-${invoice.productName}-${invoice.invoiceDate}` }
                            onClick={ onInvoiceClick }
                            invoice={ invoice }
                            isLastOnList={ invoices.length - 1 === index }
                        />
                    ))}
                </section>
            </Card>
        )
        : (
            <Card className={ theme.invoicesListEmpty } elevation={ 0 } data-testid="invoice-list">
                <span className={ theme.invoicesListEmptyText }>
                    {formatMessage('invoices.list.empty')}
                </span>
            </Card>
        )
    );
};

InvoicesList.propTypes = {
    invoices: PropTypes.arrayOf(PropTypes.shape({
        productName: PropTypes.string.isRequired,
        invoiceDate: PropTypes.string.isRequired,
        status: PropTypes.string,
        invoiceNumber: PropTypes.string.isRequired,
        total: PropTypes.shape({
            currency: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
        }).isRequired,
    })).isRequired,
    theme: PropTypes.shape({}),
    onInvoiceClick: PropTypes.func,
    i18n: i18nPropTypes,
};

export default intlEquipped(InvoicesList);
